import React from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import { useNotifications } from '../contexts/NotificationContext';

const NotificationToasts = () => {
  const { toasts, removeToast, markAsRead } = useNotifications();

  const handleToastClose = (toast) => {
    removeToast(toast.id);
    // УБИРАЕМ автоматическую отметку как прочитанное при закрытии
    // if (toast.notificationId) {
    //   markAsRead(toast.notificationId);
    // }
  };

  const handleToastClick = (toast) => {
    // ТОЛЬКО при явном клике на уведомление отмечаем как прочитанное
    if (toast.notificationId) {
      markAsRead(toast.notificationId);
    }
    removeToast(toast.id);
  };

  const getToastVariant = (type) => {
    switch (type) {
      case 'success': return 'success';
      case 'warning': return 'warning';
      case 'error': return 'danger';
      case 'system': return 'primary';
      default: return 'info';
    }
  };

  const getToastIcon = (type) => {
    switch (type) {
      case 'success': return 'bi-check-circle-fill';
      case 'warning': return 'bi-exclamation-triangle-fill';
      case 'error': return 'bi-x-circle-fill';
      case 'system': return 'bi-gear-fill';
      default: return 'bi-info-circle-fill';
    }
  };

  const getToastHeaderClass = (type) => {
    switch (type) {
      case 'success': return 'bg-success text-white';
      case 'warning': return 'bg-warning text-dark';
      case 'error': return 'bg-danger text-white';
      case 'system': return 'bg-primary text-white';
      default: return 'bg-info text-white';
    }
  };

  return (
    <ToastContainer 
      position="top-end"
      className="p-3"
      style={{ zIndex: 1060 }}
    >
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          className="notification-toast mb-3 shadow-lg border-0"
          onClose={() => handleToastClose(toast)}
          onClick={() => handleToastClick(toast)}
          delay={8000}
          autohide
          style={{ 
            cursor: 'pointer',
            borderRadius: '12px',
            overflow: 'hidden',
            minWidth: '320px',
            backdropFilter: 'blur(10px)'
          }}
        >
          <Toast.Header 
            className={getToastHeaderClass(toast.type)}
            style={{ 
              borderBottom: '1px solid rgba(255,255,255,0.2)',
              padding: '12px 16px'
            }}
          >
            <i className={`bi ${getToastIcon(toast.type)} me-2`}></i>
            <strong className="me-auto" style={{ fontSize: '0.95rem' }}>
              {toast.title}
            </strong>
            <small className="opacity-80">только что</small>
          </Toast.Header>
          <Toast.Body 
            className="bg-light"
            style={{ 
              padding: '16px',
              fontSize: '0.9rem',
              lineHeight: '1.4'
            }}
          >
            <div className="d-flex align-items-start">
              <div className="flex-grow-1">
                {toast.message}
              </div>
           
            </div>
            <div className="mt-2 text-muted small">
              Нажмите, чтобы отметить прочитанным
            </div>
          </Toast.Body>
        </Toast>
      ))}
    </ToastContainer>
  );
};

export default NotificationToasts;